import React, { useEffect, useState } from "react";
import Styles from "../../assets/css/components/dashboard/dashboard.module.scss";
import PastTransaction from "../pastTransaction/PastTransaction";
import { ResponsiveContainer, XAxis, YAxis, Tooltip, LineChart, Line } from "recharts";
import ProductImage from "../../assets/images/Dashboard/product.webp";
import { getUserReport } from '../../services/Api';
import { formatSingaporeNumber } from '../../utils/numberFormatter';

const Dashboard = () => {
    const [reportData, setReportData] = useState(null);
    const [reportLoading, setReportLoading] = useState(false);
    const [error, setError] = useState(null);
    const id = "your_user_id"; // Replace with the actual user ID

    const stockData = [
        { name: "Jan", stock: 100 },
        { name: "Feb", stock: 120 },
        { name: "Mar", stock: 90 },
        { name: "Apr", stock: 130 },
        { name: "May", stock: 110 },
        { name: "Jun", stock: 105 },
        { name: "Jul", stock: 125 },
    ];

    const fetchUserReport = async () => {
        setReportLoading(true);
        setError(null); // Reset error state
        try {
            const response = await getUserReport(id);
            if (response.status === 200) {
                setReportData(response.data);
            } else {
                throw new Error('Failed to fetch data');
            }
        } catch (error) {
            console.error("Error fetching company report:", error);
            setError('Failed to fetch company report');
        } finally {
            setReportLoading(false);
        }
    };

    useEffect(() => {
        fetchUserReport();
    }, []); // Empty dependency array means this runs once on mount

    return (
        <div className={`${Styles.dashboard}`}>
            <div className={`${Styles.dashboard_heading}`}>
                <h2>Stock Levels</h2>
            </div>

            <div className={`${Styles.report_cards}`}>
                {/* Stock Movement Card */}
                <div className={`${Styles.stock_card}`}>
                    <div className={`${Styles.content}`}>
                        <h1>Total stock movement</h1>
                        <h2>{reportLoading ? 'Loading...' : formatSingaporeNumber(reportData ? reportData.total_stock : 'N/A')}</h2>
                        <p><span style={{ color: "green" }}>40%</span> Vs last month</p>
                    </div>
                    <div className={`${Styles.chart}`}>
                        <ResponsiveContainer width={200} height={100}>
                            <LineChart data={stockData}>
                                <XAxis dataKey="name" hide />
                                <YAxis hide />
                                <Tooltip />
                                <Line type="monotone" dataKey="stock" stroke="#3E54AC" strokeWidth={2} />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                {/* SKU Card */}
                <div className={`${Styles.sku_card}`}>
                    <div className={`${Styles.content}`}>
                        <h1>Total SKUs</h1>
                        <h2>{reportLoading ? 'Loading...' : formatSingaporeNumber(reportData ? reportData.total_skus : 'N/A')}</h2>
                    </div>
                    <div className={`${Styles.product_image}`}>
                        <img src={ProductImage} alt="Product Image" />
                    </div>
                </div>
            </div>

            {error && <div className={`${Styles.error_message}`}>{error}</div>}

            <div className={`${Styles.transactions_table}`}>
                <PastTransaction showHeading={false} />
            </div>
        </div>
    );
};

export default Dashboard;
